import React from 'react';
import PropTypes from 'prop-types';

/**
 * Computer details for the office copy view. Machine logins live in Dash.
 *
 * @param {object} props
 * @param {string} props.systematicName
 * @param {string} props.OS
 * @param {string} props.location
 * @param {boolean} props.isAvInstalled
 * @param {string} props.avName
 * @returns {JSX.Element}
 */
const CopyComputerInfo = ({
    systematicName,
    OS,
    location,
    isAvInstalled,
    avName
}) => {
    return (
        <>
            <p>Computer Systematic Name: {systematicName}</p>
            <p>OS: {OS}</p>
            {isAvInstalled ? (
                <>
                    <p>AV is installed</p>
                    <p>AV Name: {avName}</p>
                </>
            ) : (
                <p>AV is not installed</p>
            )}
            <p style={{ marginTop: '0em' }}>Office Location: {location}</p>
        </>
    );
};

CopyComputerInfo.propTypes = {
    systematicName: PropTypes.string.isRequired,
    OS: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    isAvInstalled: PropTypes.bool.isRequired,
    avName: PropTypes.string.isRequired
};

export default CopyComputerInfo;
